<template lang="pug">
  .component-plan-setup
    .action-bar
      h2 Plan settings
    .tabs-inner-content
      .row(v-if="plan")
        .columns
          .row
            .column
              label Plan Name
              .field-value {{item.name}}
              label Status
              .field-value {{item.status}}
              label Color
              span {{item.color}}
              label Notice
              span {{item.notice}}
            .column
              label Duration (days)
              .field-value {{item.duration}}
              legend The contractual commitment of the plan (days).
              label Subscription End
              .field-value {{item.subscription_end}}
              label Max Drivers
              .field-value {{item.max_drivers}}
              label Renewable
              span.fa.fa-check(:class="{'success-text':item.renewable}")

              label Featured
              span.fa.fa-check(:class="{'success-text':item.featured}")
          .row
            .column.small-12
              label Description
              div(v-html="plan.description")

        .columns.small-12.large-6

          .row
            .columns
              label Cost
                .help-text {{$priceWithcurrency($priceWithVat(plan.cost))}} included vat
            .columns(v-if="item.renewable")
              label Billing Cycle (days)
              .field-value {{item.billing_cycle}}

          .row
            .columns.large-6
              label Active From
              .field-value {{item.valid_from}}

            .columns.large-6
              label Active To
              .field-value {{item.valid_to}}
          .row(v-if="item.toc")
            .columns
              label Toc
              .field-value T{{item.toc.id}} {{item.toc.name}}

          .row(v-if="item.picture")
            .column(:style="planPictureStyle")
              //KeplerFileUpload(@sel="handleFileSelector", :previewOnly="true", selected-prefix="plans", selected-visibility="public", :previewUrl="plan.picture")
    .plan-reservation-rates(v-if="$route.params.id")
      .action-bar
        .title
          h2 Plan reservation rate
        .action
          i.fa.fa-plus-circle.fa-2x(@click="$router.push({path:'add-plan-reservation-rate'})")

      .tabs-inner-content
        PlanReservationRates

</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import {mapState} from 'vuex'
import MaggieHelper from '../../../maggieHelper'
import DatePicker from '../../structure/DatePicker'
import KeplerFileUpload from '../../structure/KeplerFileUpload'
import PlanReservationRates from './PlanReservationRates'
import SelectizeToc from '../../structure/ui/lists/selectize/SelectizeToc'

export default {
  name: 'PlanSetup',
  components: {SelectizeToc, PlanReservationRates, KeplerFileUpload, DatePicker},
  data() {
    return {
      plan: null,
      vat: false,
      readOnly: true,
      mock: {
        name: null,
        toc_id: null,
        picture: null,
        title: null,
        description: null,
        cost: 0,
        status: null,
        featured: false,
        renewable: true,
        billing_cycle: 90,
        max_drivers: 1,
        duration: 30,
        subscription_end: null,
        valid_from: null,
        valid_to: null,
        color: null
      }
    }
  },
  created() {

    KeplerBackofficeSdk.plans.select(this.$route.params.id).get((data) => {
      this.plan = data
      this.plan.toc_id = data.toc ? data.toc.id : null
    })
  },

  methods: {

  },
  props: {
    create: {
      type: Boolean,
      default: false
    },
    item:{}
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    planPicture() {
      return `${window.env.API_URL}/storage/${this.plan.picture}`
    },
    planPictureStyle() {
      return {
        backgroundImage: `url(${this.planPicture})`,
        height: '200px',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
      }
    },
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

.component-plan-setup
  background: white

  textarea
    resize: none

  input, textarea, select
    &.disabled
      border: none
      box-shadow: none
      background: transparent none
      cursor: auto
      margin: 0
      padding: 0

</style>



// WEBPACK FOOTER //
// PlanSetup.vue?54cda1f7